// extracted by mini-css-extract-plugin
module.exports = {"popupBody":"PopupBody_popupBody__o1T13"};